"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _propTypes = require("prop-types");

var _styles = require("@qc-modules/styles");

var _primitives = _interopRequireDefault(require("../../primitives"));

var _utils = require("../../utils");

var _excluded = ["borderColor", "hasFocus"],
    _excluded2 = ["borderColor"],
    _excluded3 = ["tag", "children", "error", "fieldId", "handleMouseOut", "handleMouseOver", "hasFocus", "hasHover", "showValue", "success"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var InputBox = (0, _styledComponents["default"])(function (_ref) {
  var borderColor = _ref.borderColor,
      hasFocus = _ref.hasFocus,
      props = _objectWithoutPropertiesLoose(_ref, _excluded);

  return /*#__PURE__*/_react["default"].createElement(_primitives["default"].Flex, props);
}).withConfig({
  displayName: "container__InputBox",
  componentId: "sc-1g0o1ty-0"
})(["position:relative;min-width:161px;border-radius:8px;border:1px solid ", ";display:inline-flex;", ";"], function (_ref2) {
  var borderColor = _ref2.borderColor,
      props = _objectWithoutPropertiesLoose(_ref2, _excluded2);

  return (0, _styles.colors)(borderColor, props);
}, (0, _styles.transitionEase)("0.3s", ["border", "box-shadow"]));
var defaultProps = {
  tag: "label"
};
var propTypes = {
  /** Children node */
  children: _propTypes.node,

  /** A boolean to represent whether the input field has a status of error */
  error: _propTypes.bool,

  /** id string */
  fieldId: _propTypes.string,

  /** Mouse out handler */
  handleMouseOut: _propTypes.func,

  /** Mouse over handler */
  handleMouseOver: _propTypes.func,

  /** Bool if element has focus */
  hasFocus: _propTypes.bool,

  /** Bool if element has hover */
  hasHover: _propTypes.bool,

  /** A boolean to represent whether the value should be shown */
  showValue: (0, _propTypes.oneOfType)([_propTypes.bool, _propTypes.string]),

  /** A boolean to represent whether the input field has a status of success */
  success: _propTypes.bool,

  /** type of tag used */
  tag: _propTypes.string,

  /** A boolean to represent whether the input field has a status of success */
  topLabel: _propTypes.node
};

var Container = function Container(_ref3) {
  var tag = _ref3.tag,
      children = _ref3.children,
      error = _ref3.error,
      fieldId = _ref3.fieldId,
      handleMouseOut = _ref3.handleMouseOut,
      handleMouseOver = _ref3.handleMouseOver,
      hasFocus = _ref3.hasFocus,
      hasHover = _ref3.hasHover,
      showValue = _ref3.showValue,
      success = _ref3.success,
      props = _objectWithoutPropertiesLoose(_ref3, _excluded3);

  return /*#__PURE__*/_react["default"].createElement(InputBox, _extends({
    alignItems: "center",
    backgroundColor: "background",
    borderColor: (0, _utils.getBorderColor)({
      error: error,
      hasFocus: hasFocus,
      hasHover: hasHover,
      showValue: showValue
    }),
    forwardedAs: tag,
    hasFocus: hasFocus,
    htmlFor: fieldId,
    onBlur: handleMouseOut,
    onFocus: handleMouseOver,
    onMouseOut: handleMouseOut,
    onMouseOver: handleMouseOver,
    px: 1,
    success: success
  }, props), children);
};

Container.defaultProps = defaultProps;
Container.propTypes = propTypes;
Container.displayName = "Modules.FormUiContainer";
var _default = Container;
exports["default"] = _default;